import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getFinAjeerData = createAsyncThunk("api/ajeer?type=3", async (token) => {
    try {
        const response = await nodeinstance.get("/ajeer?type=3", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const FinAjeerDataSlice = createSlice({
    name: "absher",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFinAjeerData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getFinAjeerData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFinAjeerData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getFinAjeerData };
export default FinAjeerDataSlice.reducer;
